import styled from 'styled-components';

/**
 * A run of messages quoted from the thread, one bubble each.
 *
 * The ticket carries them as one string with a blank line between messages
 * (a merchant's later message is appended under one), and drawn as a single
 * block two requests about two different customers read as one garbled
 * sentence. Bubbles shrink to their own text, as they do in the chat.
 */
export const QuoteList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  margin-top: 6px;
  max-width: 100%;
`;

/**
 * One quoted message, drawn the way the chat draws it so the two screens
 * agree: what the merchant wrote is a white card with an edge to sit on the
 * cream, what support sent back is the brand red. Same padding, radius and
 * type as the thread's own Bubble.
 */
export const Quote = styled.div<{ $own?: boolean }>`
  max-width: 100%;
  padding: 7px 12px;
  border-radius: 16px;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 14px;
  line-height: 20px;
  background: ${({ theme, $own }) => ($own ? theme.primary : theme.white)};
  color: ${({ theme, $own }) => ($own ? theme.white : theme.darkGray)};
  border: ${({ theme, $own }) => ($own ? 'none' : theme.borders.border1)};
  box-shadow: ${({ theme, $own }) => ($own ? 'none' : theme.shadows.shadow2)};
`;

/**
 * Holds a text button that sits beside a paragraph rather than in the row of
 * real buttons. TextButton is 100% wide by default, which would make the whole
 * line clickable; shrink-wrapping it keeps the target on the words. Underlines
 * on hover so a line of coloured text reads as something to press.
 */
export const InlineAction = styled.div`
  width: fit-content;
  max-width: 100%;
  flex: none;

  button:hover {
    text-decoration: underline;
  }
`;
